@if (projectDetails(); as projectDetail) {
  <section class="header-wrap text-white">
    <div class="header-bg">
      <img [src]="imgSrc()!" alt="" class="w-100 h-100 object-fit-cover" />
    </div>
    <div class="header-overlay"></div>

    <div class="header-content">
      <div class="header-grid">
        <div class="left-area">
          <div class="d-flex flex-column h-100">
            <div class="row g-4 align-items-stretch left-top mb-0-75">
              <div class="col-12 col-md-auto d-flex mb-0-75">
                <div class="img-card img-card-w h-100">
                  <img [src]="imgSrc()!" alt="" />
                </div>
              </div>

              <div class="col-12 col-md mb-0-75">
                <div class="d-flex flex-column h-100">
                  <div class="rating-badge bg-success mb-3">
                    <div
                      class="fw-medium"
                      style="
                        font-size: 11px;
                        line-height: 1.2;
                        font-family: &quot;Poppins&quot;, sans-serif;
                      "
                    >
                      {{ "projectDetails.header.rating" | translate }}
                    </div>
                    <div
                      class="fw-bold"
                      style="
                        font-size: 33px;
                        line-height: 33px;
                        font-family: &quot;Poppins&quot;, sans-serif;
                      "
                    >
                      {{ projectDetail.classification.code.replace("-", "") }}
                    </div>
                  </div>

                  <h1 class="header-title mb-3">{{ projectDetail.name }}</h1>

                  <div class="header-lead" #descEl>
                    @for (p of descriptionParagraph; track $index) {
                      <p class="mb-3">
                        {{ p }}
                      </p>
                    }
                  </div>
                  @if (showReadMoreLink()) {
                    <a
                      href="#project-description"
                      (click)="scrollToProjectDescription($event)"
                      class="read-more-link"
                      style="
                        font-family: &quot;Poppins&quot;, sans-serif;
                        font-weight: 400;
                        font-size: 13px;
                        cursor: pointer;
                      "
                    >
                      {{ "projectDetails.header.readMore" | translate }}
                    </a>
                  }
                </div>
              </div>
            </div>

            <div class="header-footer mt-4">
              <div
                class="d-flex flex-column flex-sm-row gap-3 gap-sm-5 small text-white-80"
              >
                <div class="d-flex align-items-center gap-2">
                  <span class="fas fa-user"></span>
                  <span>{{ projectDetail.projectOwner.name }}</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <span class="fas fa-map-marker-alt"></span>
                  <span
                    >{{ projectDetail.country }}, {{ projectDetail.city }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-card">
          <div class="card shadow-falcon h-100">
            <div class="card-body">
              <div class="target-amount gray-800">
                {{ projectDetail.targetAmount | number }}
                {{ projectDetail.currency }}
              </div>

              <div class="amount gray-900 mt-1">
                {{ projectDetail.currentAmount | number }}
                {{ projectDetail.currency }}
              </div>

              <div class="details-p gray-800 mt-1">
                {{ "projectDetails.header.collected" | translate }}
              </div>
              <div class="details-p gray-800 mt-1">
                {{
                  projectDetail.targetAmount - projectDetail.currentAmount
                    | number
                }}
                {{ projectDetail.currency }}
                {{ "projectDetails.header.remainingInvestment" | translate }}
              </div>

              @if (isInvestOpen()) {
                <div
                  class="progress rounded-pill mt-0-75 progress-thin"
                  style="height: 3px"
                  role="progressbar"
                  [attr.aria-valuenow]="
                    (projectDetail.currentAmount / projectDetail.targetAmount) *
                    100
                  "
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <div
                    class="progress-bar rounded-pill"
                    [style.width.%]="
                      (projectDetail.currentAmount /
                        projectDetail.targetAmount) *
                      100
                    "
                  ></div>
                </div>

                @if (projectDetail.endCollectionDate) {
                  <div class="mt-0-75 time-left gray-900">
                    {{ "projectDetails.header.timeLeft" | translate }}
                    <span>{{
                      projectDetail.endCollectionDate | daysUntil
                    }}</span>
                  </div>
                }
              }

              <hr class="mt-0-75 mb-0-75" />

              <div class="d-grid gap-1 small">
                <div class="d-flex justify-content-between gap-3">
                  <span class="details-info gray-800">{{
                    "projectDetails.header.collectionPeriod" | translate
                  }}</span>
                  <span class="details-date text-end gray-900"
                    >{{ getDateString(projectDetail.startCollectionDate) }} -
                    {{ getDateString(projectDetail.endCollectionDate) }}</span
                  >
                </div>
                <div class="d-flex justify-content-between gap-3">
                  <span class="details-info gray-800">{{
                    "projectDetails.header.implementationStart" | translate
                  }}</span>
                  <span class="details-date text-end gray-900">{{
                    getDateString(projectDetail.loanTypePaymentStart)
                  }}</span>
                </div>
                <div class="d-flex justify-content-between gap-3">
                  <span class="details-info gray-800">{{
                    "projectDetails.header.implementationEnd" | translate
                  }}</span>
                  <span class="details-date text-end gray-900">{{
                    getDateString(projectDetail.loanTypePaymentEnd)
                  }}</span>
                </div>
              </div>

              <hr class="mt-0-75 mb-0-75" />

              @if (isInvestOpen()) {
                <div class="mb-0-75 gray-800 small">
                  {{ "projectCard.investmentsArePossible" | translate }}
                </div>
                <div
                  [title]="
                    !isLoggedIn()
                      ? ('projectDetails.header.loginToInvestTooltip' | translate)
                      : null
                  "
                >
                  <button
                    class="btn btn-primary w-100 fw-medium"
                    style="height: 43px; font-size: 19px"
                    [disabled]="!isLoggedIn()"
                    (click)="invest()"
                  >
                    {{ "projectDetails.header.invest" | translate }}
                  </button>
                </div>

                <div
                  class="d-flex align-items-center gap-2 mt-0-75 mb-0-75 gray-900"
                  [title]="
                    !isLoggedIn()
                      ? ('projectDetails.header.loginToInvestTooltip' | translate)
                      : null
                  "
                >
                  <app-validated-checkbox
                    [label]="'projectDetails.header.investorProtection'"
                    [value]="investmentProtection()"
                    (valueChange)="investmentProtection.set($event)"
                    [disabled]="!isLoggedIn()"
                    [leaveSpaceForValidation]="false"
                  ></app-validated-checkbox>
                  <span
                    class="fas fa-info-circle"
                    [title]="
                      'projectDetails.header.investorProtectionTooltip'
                        | translate
                    "
                  ></span>
                </div>
              }

              @if (showFollow()) {
                @if (
                  !!projectsStore.allFollowedProjectEntityMap()[
                    projectDetails().id
                  ]
                ) {
                  <a
                    class="details-follow-btn w-100"
                    (click)="unFollow(projectDetails().id)"
                  >
                    <div>
                      <span class="fas fa-heart"></span>
                      {{ "general.unFollow" | translate }}
                    </div>
                  </a>
                } @else {
                  <a
                    class="details-follow-btn w-100"
                    (click)="follow(projectDetails().id)"
                  >
                    <div>
                      <span class="far fa-heart"></span>
                      {{ "general.follow" | translate }}
                    </div>
                  </a>
                }
              }

              <div class="text-center mt-0-75 gray-800" style="font-size: 11px">
                {{ "projectDetails.header.minOffer" | translate }}
                {{ projectDetail.offerMinAmount | number }}
                {{ projectDetail.currency }}<br />
                {{ "projectDetails.header.maxOffer" | translate }}
                {{ projectDetail.offerMaxAmount | number }}
                {{ projectDetail.currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}
